import UpdateLeadStatusesStep from './updateLeadStatuses.view';

export default UpdateLeadStatusesStep;
